import { TraceType } from '../../common/enums/TraceType';
import { ProjectExceptionType } from '../enums/ProjectExceptionType';

export class ProjectException {
  constructor(
    private readonly id: number,
    private readonly projectId: number,
    private readonly type: ProjectExceptionType,
    private readonly term: string,
    private readonly description: string | null,
    private readonly active: boolean,
    private readonly traceType: TraceType
  ) {}

  getId() {
    return this.id;
  }

  getProjectId() {
    return this.projectId;
  }

  getType() {
    return this.type;
  }

  getTerm() {
    return this.term;
  }

  getDescription() {
    return this.description;
  }

  isActive() {
    return this.active;
  }

  getTraceType() {
    return this.traceType;
  }
}
